import React from 'react';

const WhatWeDoing = () => {

    return (
        <div className='container py-20'>
            <div className="flex flex-col md:flex-row gap-2 justify-between items-center mx-auto w-full">
                <div className="w-full order-2 md:order-1 md:w-3/6 mx-auto p-10 overflow-hidden">
                    <div className="w-2/3 relative h-[60vh] md:h-screen mx-auto">
                        <div className="overflow-hidden">
                            <img draggable="false" style={{ animation: `scale 30s linear infinite`, transform: `rotate(${Math.floor(Math.random() * (361))}deg)` }} src="https://elanta.app/nazar/starbelly-demo/img/illustrations/interior.jpg" alt="" className="object-cover h-[60vh] md:h-screen w-full rounded" />
                        </div>
                        <div className="absolute p-3 z-10 -right-16 shadow bottom-0 bg-white w-52">
                            <div className=" border-2 border-dotted">
                                <div className="flex flex-col text-center w-full">
                                    <h3 className="font-sans text-2xl md:text-7xl" style={{ fontFamily: "Monoton" }}>17</h3>
                                    <h3 className="font-sans text-2xl md:text-4xl font-bold" style={{ fontFamily: "Rajdhani" }}>Years <br /> Experiense</h3>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="w-full order-1 md:order-2 space-y-4 md:w-3/6 mx-auto">
                    <div className="px-5">
                        <h1 className="text-3xl md:text-6xl font-bold fw-bold capitalize" style={{ fontFamily: "Rajdhani" }}>We are doing more than
                            you expect</h1>
                    </div>
                    <div className="flex justify-start gap-2 px-5 py-1 w-full items-center">
                        <div className="">
                            <h3 className="text-3xl md:text-5xl text-[#ffaa00] capitalize" style={{ fontFamily: "Monoton" }}>01</h3>
                        </div>
                        <div className="flex flex-col py-1 px-3 gap-2">
                            <h3 className="font-bold text-xl md:text-2xl capitalize">We are located in the city center</h3>
                            <h3 className="capitalize text-sm md:text-md">Porro nemo veniam necessitatibus praesentium eligendi rem temporibus adipisci quo modi numquam.</h3>
                        </div>
                    </div>
                    <div className="flex justify-start gap-2 px-5 py-1 w-full items-center">
                        <div className="">
                            <h3 className=" text-3xl md:text-5xl text-[#ffaa00] capitalize" style={{ fontFamily: "Monoton" }}>02</h3>
                        </div>
                        <div className="flex flex-col py-1 px-3 gap-2">
                            <h3 className="font-bold text-xl md:text-2xl capitalize">Fresh, organic ingredients</h3>
                            <h3 className="capitalize text-sm md:text-md">Consectetur numquam porro nemo veniam necessitatibus praesentium eligendi rem temporibus adipisci quo modi.</h3>
                        </div>
                    </div>
                    <div className="flex justify-start gap-2 px-5 py-1 w-full items-center">
                        <div className="">
                            <h3 className=" text-3xl md:text-5xl text-[#ffaa00] capitalize" style={{ fontFamily: "Monoton" }}>03</h3>
                        </div>
                        <div className="flex flex-col py-1 px-3 gap-2">
                            <h3 className="font-bold text-xl md:text-2xl capitalize">Own fast delivery</h3>
                            <h3 className="capitalize text-sm md:text-md">Necessitatibus praesentium eligendi rem temporibus adipisci quo modi. Lorem ipsum dolor sit.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhatWeDoing;